import { Card } from 'antd'
import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const FacturationContent = styled.div`
    margin-top: 20px;
`

export const BillingSpacesContainer = styled.div<{ $loading?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 14px;
    opacity: ${({ $loading }) => $loading ? 0.5 : 1};
    pointer-events: ${({ $loading }) => $loading ? 'none' : 'auto'};
    transition: opacity 150ms ease-out;
`

export const NoBillingSpacesCard = styled(Card)`
    text-align: center;
    border-radius: 10px;
`

export const BillingStateDescription = styled.div`
    h4 {
        margin-bottom: 4px;
        font-size: 16px;
    }

    p {
        margin: 0;
        color: ${colors.steelGrey};
    }
`

export const BillingStateAction = styled.div`
    margin-top: 10px;
`

export const BillingSpaceSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 0 4px;

    & header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 12px;
        margin-top: 8px;
    }

    & .header-main {
        min-width: 0;
    }

    & .header-main > h3 {
        font-size: 20px;
        font-weight: 600 !important;
        margin-bottom: 2px;
    }

    & .header-main > p {
        color: ${colors.steelGrey};
        font-size: 13px;
        margin: 0;
    }

    & .header-right {
        flex-shrink: 0;
    }

    @media (max-width: ${measures.mobileThreshold}px) {
        & header {
            flex-direction: column;
            align-items: stretch;
        }
    }
`

export const BillingPeriodBar = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px;
    border: 1px solid ${colors.lightGrey};
    border-radius: 10px;
    background: ${colors.white};
`

export const PeriodTopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .billing-range-picker {
        width: auto !important;
        min-width: 260px;
    }

    @media (max-width: ${measures.mobileThreshold}px) {
        .billing-range-picker {
            width: 100% !important;
            min-width: 0;
        }
    }
`

export const PeriodPresets = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`

export const PeriodPresetButton = styled.button`
    border: 1px solid ${colors.lightGrey};
    background: ${colors.white};
    color: ${colors.darkGrey};
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 10px;
    cursor: pointer;

    &:hover {
        border-color: ${colors.waterBlue};
        color: ${colors.waterBlue};
    }
`

export const PeriodContextLabel = styled.div`
    color: ${colors.steelGrey};
    font-size: 13px;
`



export const BillingSpaceTableWrapper = styled.div`
    margin-top: 4px;
    border: 1px solid ${colors.lightGrey};
    border-radius: 8px;
    overflow: hidden;

    .ant-table-container {
        border: none !important;
    }

    .ant-table-tbody .ant-table-row:last-child td.ant-table-cell {
        padding-bottom: 18px;
    }

    .ant-table-thead .ant-table-cell {
        background: ${colors.lighterGrey};
        color: #000;
        font-size: 13px;
        font-weight: 600;
        line-height: 18px;
        padding: 10px 16px;
        border-bottom: 1px solid ${colors.lightGrey};
        border-right: 1px solid rgba(40, 44, 46, 0.08);
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .ant-table-thead .ant-table-cell.month-column {
        font-weight: 700;
    }

    .ant-table-thead .ant-table-cell:last-child,
    .ant-table-tbody .ant-table-row td.ant-table-cell:last-child {
        border-right: none;
    }

    .ant-table-tbody .ant-table-row td.ant-table-cell {
        line-height: 18px;
        padding: 10px 16px;
        border-right: 1px solid rgba(40, 44, 46, 0.08);
        transition: background-color 120ms ease-out;
    }

    .label-column {
        min-width: 240px;
        width: 240px;
        background: ${colors.footerColor};
    }

    .ant-table-cell-fix-left {
        background: ${colors.footerColor};
        z-index: 2;
    }

    .ant-table-thead .ant-table-cell-fix-left {
        background: ${colors.lighterGrey};
        z-index: 4;
    }

    .section-row td.ant-table-cell-fix-left {
        background: ${colors.white} !important;
    }

    .total-row td.ant-table-cell-fix-left {
        background: ${colors.footerColor} !important;
    }

    .metric-row:hover td.ant-table-cell {
        background: ${colors.veryLightGrey};
    }

    .section-row td.ant-table-cell {
        background: ${colors.white} !important;
        color: #000;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
    }

    .section-title {
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }

    .metric-row td.ant-table-cell {
        border-bottom: 1px solid ${colors.lightGrey};
        color: #000;
        font-size: 13px;
        font-weight: 600;
    }

    .metric-row td.ant-table-cell.label-column {
        font-size: 14px;
    }

    .metric-row td.ant-table-cell:not(.label-column) {
        font-variant-numeric: tabular-nums;
    }

    .total-row td.ant-table-cell {
        font-weight: 700;
        background: ${colors.footerColor};
        border-top: 2px solid ${colors.lightGrey};
    }

    @media (max-width: ${measures.mobileThreshold}px) {
        overflow-x: auto;

        .metric-row td.ant-table-cell {
            font-size: 15px;
        }
    }
`
